import { apiRequest } from "./apiRequest";
import { errorHandler } from "./errorHandler";
import { LoginData, UserLogin } from "../interface";

export const auth = async (args: LoginData): Promise<UserLogin> => {
  try {
    return await apiRequest<UserLogin>(
      "post",
      "/auth",
      { data: args },
      false 
    );
  } catch (error) {
    errorHandler(error);
    throw new Error("Login request failed");
  }
};
